import './index.css';

export default {
  name: 'Atitle',
  props: {
    title: { type: String, default: () => '' },
    path: { type: String, default: () => '' },
    cancel: { type: Boolean, default: () => true },
    cancelText: { type: String, default: () => '返回 ' },
    cancelIcon: { type: String, default: () => '>>' },
  },
  methods: {
    handle(path) {
      if (location.pathname != path) {
        this.$router.push(path);
        this.$emit('handle', path);
      }
    },
    goBack(path) {
      this.$emit('cancel', path);
    },
  },
  render() {
    return (
      <div class="a-title">
        {this.title != '' && (
          <div class="a-title-body">
            <div>{this.text || this.title || this.label}</div>
            {this.more ? () => this.more(this) : (
              <div>{this.path != '' ? (
                <a class="link" href="javascript:" onClick={() => this.handle(this.to || this.path || this.link)}>
                  <span class="text">更多</span>
                  <span class="icon">{this.cancelIcon}</span>
                </a>
              ) : ''}
              </div>
            )}
            {this.cancel && (
              <a class="link" href="javascript:" onClick={() => this.goBack(this.to || this.path || this.link)}>
                <span class="text">{this.cancelText}</span>
                <span class="icon">{this.cancelIcon}</span>
              </a>
            )}
          </div>
        )}
      </div>
    );
  }
}